import { Component } from '@angular/core';

import { environment } from '@env/environment';
import type { CardData } from '@shared/components';
import { Button, HoverExpandableCardsComponent } from '@shared/components';

@Component({
  selector: 'app-evrn-to-video',
  imports: [HoverExpandableCardsComponent, Button],
  templateUrl: './evrn-to-video.html',
  styleUrl: './evrn-to-video.scss',
})
export class EvrnToVideo {
  readonly environment = environment;
  readonly expandableCards: CardData[] = [
    {
      video: 'assets/evrn-to-video/old-man-error.webm',
      title: 'Prompt to Video\n= Slot Machine',
      description:
        'Upload a picture. Write prompts. Try variations. Batch produce angles and wrestle the prompt.',
    },
    {
      video: 'assets/evrn-to-video/old-man-correct.webm',
      title: 'EVRN to Video\n= Control',
      description:
        'Direct your scene with full control over your light, assets and exact camera angles with EVRN as the layout reference.',
    },
  ];
}
